<template>

  <div  class="main">
    <h1>welcome</h1>
  </div>
</template>

<script>
import axios from '../../utils/request'
export default {
  mounted () {
    this.weclome()
    console.log('success')
    console.log('success')
  },
  methods: {
    weclome: function () {
      axios.get('/data/welcome').then(res => {
        console.log('success')
      })
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/table/welcome.vue